(function ($) {
  'use strict';

  $(window).load(loginCheck);

  function loginCheck() {
    $('#code').mask('AA/A/AA/AAA/AAA', {
      'placeholder': '__/_/__/___/___',
      'onKeyPress': function (value, event) {
        event.currentTarget.value = value.toUpperCase();
      }
    });
  }

  $(document).ready(function () {
    var $body = $(document.body);

    $body.on('click', '#logoutpatient', function (ev) {
      ev.preventDefault();
      var data = {
        'action': 'burst_patient_logout'
      };
      // INSERT AJAX LOADER
      $.get(burstbiglogin.ajaxurl, data)
        .success(function (data) {
          window.location.href = '/';
        })
    });
  });
  module.exports = loginCheck;
}(jQuery));
